var Banner = function Banner(_ref) {
  var colors = _ref.colors,
      radii = _ref.radii;
  return {
    defaultBackgroundColor: colors.feedback.informative.light,
    border: {
      radius: radii.small
    }
  };
};

export default Banner;